import { TelemetryGeo, TelemetryGeoParams } from '@shared/interfaces/telemetry';
import { ChartOptions } from 'chart.js';
import { GeoData } from '../../../../types/GeoData';
import { topojson } from 'chartjs-chart-geo';
import { interpolateColor } from '../../../../utils/color/color';

export const createGeo = (graph: TelemetryGeo, world: GeoData) => {
  return {
    type: 'choropleth' as const,
    title: graph.title,
    options: createOptions(graph.params),
    data: buildChartData(graph.data, world),
    height: 400,
    plugins: [],
  };
};

const buildChartData = (data: TelemetryGeo['data'], world: GeoData) => {
  const countries = topojson.feature(world, world.objects.countries).features;
  const land = topojson.feature(world, world.objects.land).features;
  const input = Object.fromEntries(data.map((el) => [el['location'].toString().split(', ')[1], el['count']])); // TODO: Send better data from backend, e.g. matching names or iso numeric codes
  return {
    labels: countries.map((d) => d.properties.name),
    datasets: [
      {
        label: $localize`Countries`,
        outline: land,
        data: countries.map((d) => ({
          feature: d,
          value: input[d.properties.name] || 0,
        })),
      },
    ],
  };
};

const createOptions = (_options: TelemetryGeoParams): ChartOptions<'choropleth'> => {
  return {
    maintainAspectRatio: false,
    scales: {
      projection: { axis: 'x', projection: 'naturalEarth1' },
      color: {
        axis: 'x',
        interpolate: (v) => (v === 0 ? '#fff' : interpolateColor('#eefaff', '#004e6e', v)),
        legend: {
          position: 'left',
          length: 380,
          margin: { left: 20 },
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
    },
  };
};
